<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">Servers Lists</h4>
            <button class="pull-right btn btn-sm btn-primary" @click="openExportModal()"> <i class="fa fa-download"></i> Domain-IP List</button>
          </div>
          <div class="card-body">
            <servers-list />
          </div>
        </div>
      </div>
    </div>
    <domain-ip-list ref="export" />
  </div>
</template>

<script>
export default {
name: "SyncServers",
  components: {
    Alert: () =>
        import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
    serversList: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/SyncServers/serversList"),
    domainIpList: () =>
        import(/* webpackChunkName: "userList" */ "../../../components/Admin/DomainIpList")
  },
  computed: {
    alertType() {
      return this.$store.getters["alert/type"];
    },
    alertMessage() {
      return this.$store.getters["alert/message"];
    },
    alertShow() {
      return this.$store.getters["alert/show"];
    }
  },
  methods: {
    openExportModal () {
      console.log('opening')
      this.$refs.export.load()
    }
  }
}
</script>

<style scoped>

</style>
